<template>
  <div>
    <el-form ref="formRef" :model="scoreForm" label-width="88px">
      <el-form-item label="性别：">
        <el-select v-model="sex" placeholder="Select" style="width: 24em">
          <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分数：">
        <el-select v-model="score" placeholder="Select" style="width: 24em">
          <el-option v-for="item in scoreArray" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="评语：">
        <el-input :rows="4" type="textarea" v-model="scoreForm.msg" placeholder="100字以内" style="width:24em;"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateScore } from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      scoreForm: this.value.scoreForm,
      idx: this.value.ids,
      loading: false,

      sexArray: [
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: this.value.scoreForm.sex?this.value.scoreForm.sex:1,

      scoreArray: [],
      score: this.value.scoreForm.score?this.value.scoreForm.score:60,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    getScoreList() {
      for(let i = 0; i<=100; i++) {
        this.scoreArray.push(i);
      }
    },

    summit() {
      if(!this.scoreForm.msg) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '评语不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.scoreForm.id?this.scoreForm.id:0;
      param['msg'] = this.scoreForm.msg;
      param['sex'] = this.sex;
      param['score'] = this.score;
      postFormData(addOrUpdateScore, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
    this.getScoreList()
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
